"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType["OPEN_PAREN"] = "OPEN_PAREN";
    TokenType["CLOSE_PAREN"] = "CLOSE_PAREN";
    TokenType["MINUS"] = "MINUS";
    TokenType["PLUS"] = "PLUS";
    TokenType["SLASH"] = "SLASH";
    TokenType["STAR"] = "STAR";
    TokenType["EQUAL"] = "EQUAL";
    TokenType["MODULO"] = "MODULO";
    TokenType["BANG"] = "BANG";
    TokenType["BANG_EQUAL"] = "BANG_EQUAL";
    TokenType["GREATER"] = "GREATER";
    TokenType["GREATER_EQUAL"] = "GREATER_EQUAL";
    TokenType["LESS"] = "LESS";
    TokenType["LESS_EQUAL"] = "LESS_EQUAL";
    TokenType["IDENTIFIER"] = "IDENTIFIER";
    TokenType["STRING"] = "STRING";
    TokenType["NUMBER"] = "NUMBER";
    TokenType["IF"] = "IF";
    TokenType["ELSE"] = "ELSE";
    TokenType["NIL"] = "NIL";
    TokenType["FUN"] = "FUN";
    TokenType["NEWLINE"] = "NEWLINE";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
